export { NewUserJoinGroups as Groups } from './NewUserJoinGroups';
